import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../../environment';
import { AuthService } from '@common/services/AuthService/AuthService';
import { AreaUpdatesData } from '@common/models/areaUpdatesData.model';
import { AreaSummariesData } from '@common/models/areaSummariesData.model';
import { AreasData } from '@common/models/areasData.model';
import { AreaDetails } from '@common/models/areaDetails.model';
import { AreaAcceptResponse } from '@common/models/areaAcceptResponse.model';
import { QueryParameters } from '@common/models/queryParameters.model';
import { QueryParametersStringified } from '@common/models/queryParametersStringified.model';

@Injectable()
export class AreaService {
  constructor(
    private http: HttpClient,
    public authService: AuthService,
  ) {}

  getAreaDetails(areaKey: string): Observable<AreaDetails> {
    const endpoint = environment.endpoints.areaDetails;
    const accessToken = this.authService.getAccessToken();
    const companyKey = this.authService.getCompanyKey();

    return this.http.get<AreaDetails>(
      `${endpoint}${companyKey}/${areaKey}/`,
      {
        headers: new HttpHeaders()
          .set('Authorization', `Bearer ${accessToken}`)
          .set('language', navigator.language),
      },
    );
  }

  getAreaUpdates(queryParameters: QueryParameters): Observable<AreaUpdatesData> {
    const endpoint = environment.endpoints.areasToUpdate;
    const accessToken = this.authService.getAccessToken();
    const companyKey = this.authService.getCompanyKey();

    const params: QueryParametersStringified = {
      query: queryParameters.query,
      orderBy: queryParameters.orderBy,
      sortOrder: queryParameters.sortOrder,
      page: queryParameters.page.toString(),
    };

    return this.http.get<AreaUpdatesData>(
      `${endpoint}${companyKey}/`,
      {
        params,
        headers: new HttpHeaders()
          .set('Authorization', `Bearer ${accessToken}`)
          .set('language', navigator.language),
      },
    );
  }

  acceptAreaUpdate(updateId: number): Observable<AreaAcceptResponse> {
    const endpoint = environment.endpoints.areaAccept;
    const accessToken = this.authService.getAccessToken();
    const companyKey = this.authService.getCompanyKey();

    return this.http.post<AreaAcceptResponse>(
      `${endpoint}${companyKey}/${updateId}/`,
      null,
      {
        headers: new HttpHeaders()
          .set('Authorization', `Bearer ${accessToken}`)
          .set('language', navigator.language),
      },
    );
  }

  getAreaSummaries(queryParameters: QueryParameters): Observable<AreaSummariesData> {
    const endpoint = environment.endpoints.areaSummaries;
    const accessToken = this.authService.getAccessToken();
    const companyKey = this.authService.getCompanyKey();

    const params: QueryParametersStringified = {
      query: queryParameters.query,
      orderBy: queryParameters.orderBy,
      sortOrder: queryParameters.sortOrder,
      page: queryParameters.page.toString(),
    };

    return this.http.get<AreaSummariesData>(
      `${endpoint}${companyKey}/`,
      {
        params,
        headers: new HttpHeaders()
          .set('Authorization', `Bearer ${accessToken}`)
          .set('language', navigator.language),
      },
    );
  }

  getAreas(clientKey: string, queryParameters: QueryParameters): Observable<AreasData> {
    const endpoint = environment.endpoints.areas;
    const accessToken = this.authService.getAccessToken();
    const companyKey = this.authService.getCompanyKey();

    const params: QueryParametersStringified = {
      query: queryParameters.query,
      orderBy: queryParameters.orderBy,
      sortOrder: queryParameters.sortOrder,
      page: queryParameters.page.toString(),
    };

    return this.http.get<AreasData>(
      `${endpoint}${companyKey}/${clientKey}/`,
      {
        params,
        headers: new HttpHeaders()
          .set('Authorization', `Bearer ${accessToken}`)
          .set('language', navigator.language),
      },
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/AreaService/AreaService.ts